import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Slide,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import BusinessIcon from '@mui/icons-material/Business';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import CategoryIcon from '@mui/icons-material/Category';

// Componente de transición
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Componente para mostrar un campo con label
const InfoField = ({ label, value, color = "rgba(23, 66, 136, 0.85)" }) => (
  <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5, fontSize: 12 }}>
    <Typography component="span" sx={{ fontWeight: 600, color: "#64748b", fontSize: 11 }}>
      {label}:
    </Typography>
    <Typography component="span" sx={{
      color,
      fontWeight: 500,
      fontSize: 12,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: 200
    }}>
      {value || "—"}
    </Typography>
  </Box>
);

const CargarFlujoDialog = ({
  open,
  onClose,
  availableFlows = [],
  contextOptions = [],
  onLoadFlow,
  onDeleteFlow,
  // Props para Super Admin
  isSuperAdmin = false,
  empresas = [],
  selectedEmpresaFilter = null,
  onEmpresaFilterChange = () => {}
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: "#f8fafc",
          boxShadow: "0 8px 32px rgba(99, 102, 241, 0.15)",
          border: "none",
          overflow: "hidden"
        }
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
          color: "#fff",
          py: 2,
          px: 3
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <FolderSpecialIcon sx={{ fontSize: 26, color: "#fbbf24" }} />
          <Typography sx={{ fontWeight: 700, fontSize: 20, letterSpacing: 0.5 }}>
            Flujos Guardados
          </Typography>
          <Chip
            label={`${availableFlows.length} flujos`}
            size="small"
            sx={{
              ml: 1,
              background: "rgba(255,255,255,0.2)",
              color: "#fff",
              fontWeight: 600,
              fontSize: 11
            }}
          />
        </Box>
        {isSuperAdmin && (
          <Chip
            icon={<AdminPanelSettingsIcon sx={{ fontSize: 16, color: "#fff !important" }} />}
            label="Super Admin"
            size="small"
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              fontWeight: 600,
              fontSize: 11
            }}
          />
        )}
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {/* Filtro de empresa para Super Admin */}
        {isSuperAdmin && empresas.length > 0 && (
          <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #e2e8f0", background: "#fff" }}>
            <FormControl fullWidth size="small">
              <InputLabel id="empresa-filter-label">Filtrar por empresa</InputLabel>
              <Select
                labelId="empresa-filter-label"
                value={selectedEmpresaFilter || ""}
                label="Filtrar por empresa"
                onChange={(e) => onEmpresaFilterChange(e.target.value || null)}
                sx={{ borderRadius: 2, background: "#f8fafc" }}
              >
                <MenuItem value="">
                  <em>Todas las empresas</em>
                </MenuItem>
                {empresas.map((empresa) => (
                  <MenuItem key={empresa.id} value={empresa.id}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <BusinessIcon sx={{ fontSize: 16, color: "#6366f1" }} />
                      <span>{empresa.nombre || empresa.company}</span>
                      <Chip label={`${empresa.chatbots_count}`} size="small" sx={{ ml: 1, fontSize: 10, height: 18 }} />
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        {/* Lista de flujos */}
        <Box sx={{ maxHeight: 450, overflowY: "auto", p: 2 }}>
          {availableFlows.length === 0 ? (
            <Box sx={{
              p: 4,
              textAlign: "center",
              color: "#64748b"
            }}>
              <FolderSpecialIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
              <Typography sx={{ fontWeight: 500, fontSize: 15 }}>
                No hay flujos guardados
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {availableFlows.map(flow => (
                <Box
                  key={flow.id}
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      background: "#f1f5f9",
                      borderColor: "#6366f1",
                      boxShadow: "0 2px 8px rgba(99, 102, 241, 0.15)"
                    }
                  }}
                  onClick={() => onLoadFlow(flow)}
                >
                  {/* Fila principal */}
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                    {/* Icono */}
                    <Box sx={{
                      width: 36,
                      height: 36,
                      borderRadius: 1.5,
                      background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}>
                      <FolderSpecialIcon sx={{ fontSize: 20, color: "#d97706" }} />
                    </Box>

                    {/* Info del flujo */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      {/* Nombre del flujo */}
                      <Typography sx={{
                        fontWeight: 700,
                        color: "#1e3a5f",
                        fontSize: 14,
                        mb: 0.5,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}>
                        {flow.name}
                      </Typography>

                      {/* Grid de información compacta */}
                      <Box sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.5,
                        mb: 0.5
                      }}>
                        <InfoField
                          label="Descripción"
                          value={flow.description || "Sin descripción"}
                        />
                        <InfoField
                          label="Contexto"
                          value={contextOptions.find(opt => opt.id === flow.id_contexto)?.nombre || "Sin contexto"}
                          color="#10b981"
                        />
                        {isSuperAdmin && (
                          <>
                            <InfoField
                              label="Propietario"
                              value={flow.owner?.name || "—"}
                              color="#7c3aed"
                            />
                            <InfoField
                              label="Empresa"
                              value={flow.empresa?.nombre || "—"}
                              color="#2563eb"
                            />
                          </>
                        )}
                      </Box>

                      {/* WhatsApp si existe */}
                      {flow.whatsapp_number && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
                          <WhatsAppIcon sx={{ fontSize: 12, color: "#25D366" }} />
                          <Typography sx={{ fontSize: 11, color: "#25D366", fontWeight: 500 }}>
                            {flow.whatsapp_number}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Botones de acción */}
                    <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                      <Tooltip title="Cargar flujo" arrow>
                        <IconButton
                          size="small"
                          onClick={(e) => { e.stopPropagation(); onLoadFlow(flow); }}
                          sx={{
                            background: "#e0e7ff",
                            color: "#4338ca",
                            "&:hover": { background: "#4338ca", color: "#fff" }
                          }}
                        >
                          <DownloadIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Eliminar flujo" arrow>
                        <IconButton
                          size="small"
                          onClick={(e) => { e.stopPropagation(); onDeleteFlow(flow); }}
                          sx={{
                            background: "#fee2e2",
                            color: "#dc2626",
                            "&:hover": { background: "#dc2626", color: "#fff" }
                          }}
                        >
                          <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", background: "#fff" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            px: 3,
            borderColor: "#e2e8f0",
            color: "#64748b",
            "&:hover": { background: "#f1f5f9", borderColor: "#94a3b8" }
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CargarFlujoDialog;
